import { useEffect, useState } from 'react';
import freeSens from 'assets/img/new-logoo.svg';
import webLogo from 'assets/img/web-login-logo.svg';
import styled from 'styled-components';
import { useMediaQuery } from 'hooks/useMediaQuery';

export const LoginBanner = ({ crm }) => {
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  const handleResize = () => {
    setInnerHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Wrapper innerHeight={innerHeight}>
      <img className="desktop-freesens-logo" src={webLogo} alt="" />
      <div className="mobile-header">
        <img src={freeSens} alt="" className="mobile-freesens-logo " />
        {crm && <div className="crm-text">CRM</div>}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .mobile-header {
    display: ${({ innerHeight }) => (innerHeight < 520 ? 'none' : 'flex')};
    justify-content: center;
    align-items: start;
    width: 100%;
    height: 240px;
    text-align: center;
    background-image: linear-gradient(296.02deg, #753cbe 0%, #3cc0c3 100%);
  }
  .mobile-freesens-logo {
    margin: auto;
  }
  .crm-text {
    top: 210px;
    position: absolute;
    margin: 0 auto 0;
    font-size: 18px;
    color: #d8d8d8;
    height: 25px;
    letter-spacing: 1.8px;
    text-align: center;
  }
  .desktop-freesens-logo {
    display: none;
    margin: auto;
    min-height: 50px;
  }
  @media screen and (min-width: 1024px) {
    .mobile-header {
      display: none;
    }
    .desktop-freesens-logo {
      display: block;
    }
  }
`;
